var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 39,
    viewBox: "0 0 18 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.3628 0H10.8512C7.03062 0 3.93279 3.09784 3.93279 6.91919V12.4025H0.483939C0.2165 12.4025 0 12.619 0 12.8864V18.5735C0 18.8409 0.2165 19.0574 0.483939 19.0574H3.93279V19.3599V37.9326C3.93279 38.1992 4.14929 38.4165 4.41673 38.4165H11.3136C11.5811 38.4165 11.7976 38.2 11.7976 37.9326V19.0566H16.7977C17.0492 19.0566 17.2586 18.8648 17.2801 18.6141L17.7608 12.927C17.7847 12.6445 17.5618 12.4025 17.2785 12.4025H11.7976V8.36782C11.7976 7.42223 12.5641 6.65573 13.5105 6.65573H17.3636C17.6311 6.65573 17.8476 6.43924 17.8476 6.1718V0.484734C17.8468 0.216499 17.6303 0 17.3628 0Z",
    fill: "#0047AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.74fbf8831fb7c8a92497ff445a369532.svg";
export { ForwardRef as ReactComponent };